// Single source for status colour across the CRM. One recipe everywhere:
// a tinted chip with -700 text on light and -300 on dark, so contrast holds in
// both themes. Class names are written out in full so Tailwind can see them.
export const tone = {
  positive: {
    chip: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300",
    text: "text-emerald-700 dark:text-emerald-300",
    dot: "bg-emerald-500",
  },
  warning: {
    chip: "bg-amber-500/10 text-amber-700 dark:text-amber-300",
    text: "text-amber-700 dark:text-amber-300",
    dot: "bg-amber-500",
  },
  negative: {
    chip: "bg-red-500/10 text-red-700 dark:text-red-300",
    text: "text-red-700 dark:text-red-300",
    dot: "bg-red-500",
  },
  info: {
    chip: "bg-sky-500/10 text-sky-700 dark:text-sky-300",
    text: "text-sky-700 dark:text-sky-300",
    dot: "bg-sky-500",
  },
  neutral: {
    chip: "bg-muted text-muted-foreground",
    text: "text-muted-foreground",
    dot: "bg-muted-foreground",
  },
} as const

export type Tone = keyof typeof tone
